import React, { FC } from 'react';
import styled from 'styled-components';
import { fadeOut } from '../../styles/styles';

type FadeOutProps = {
	color: 'white' | 'black';
};

export const FadeOut: FC<FadeOutProps> = ({ color }) => {
	return <Wrap color={color} />;
};

const Wrap = styled.div<{ color: 'white' | 'black' }>`
	width: 100vw;
	height: 100vh;
	background: ${({ color }) => color};
	position: fixed;
	z-index: 1000000;
	animation: ${fadeOut} 1s;
	opacity: 0;
	visibility: hidden;
`;
